<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="「TOMORROW X TOGETHER」イベント開始！" />
    <div data-v-1ae908a8="">
      <div data-v-3c4f816c="" class="text-area">
        24.06.03<br /><br />TOMORROW X TOGETHERの人気曲「Sugar Rush
        Ride」の世界をイメージしたセガ描き下ろしイラストでi my merryに登場！<br /><br />期間限定で、オリジナルデザインのスタンプやシールが楽しめます。<br /><br />
        <center>
          <img
            src="@/assets/Png/News/TXT2/20240603_txt2_01.png"
            style="max-width: 100%;"
          />
        </center>
        <br /><br />■実施期間<br />2024年6月3日(月) ～ 6月30日(日)<br /><br />■対象機種<br />全国の「i
        my merry（アイマイメリー）」<br /><br />
        <center>
          <img
            src="@/assets/Png/News/TXT2/20240603_txt2_02.png"
            style="max-width: 80%;"
          />
        </center>
        <br /><br />
        <center>
          <a href="https://puri.sega.jp/location-map/?id=imymerry"
            ><u>i my merry設置店舗はこちら</u></a
          >
        </center>
        <br /><br />■内容<br />スタンプ全22種、シールデザイン1種<br />
        <center>
          <img
            src="@/assets/Png/News/TXT2/20240603_txt2_03.png"
            style="max-width: 100%;"
          />
        </center>
        <br /><br />シールが出てきたら、<br />連動アプリ「プリクラON」で<br />プリデータのダウンロードも忘れずに♪<br /><br />ダウンロードすると、<br />3秒動画「モーメント」も見れるよ！<br />SNSにもアップしてね♪<br /><br />プリクラONのカメラで<br />撮影したシールを見ると<br />シールが動く「ARプリクラ」も<br />楽しめるから試してみてね♪<br /><br />■TOMORROW
        X TOGETHER プロフィール<br />韓国の5人組ボーイグループ。グループ名は“それぞれ違う君と僕がひとつの夢で集まって共に明日を作って行く”という意味から。<br />2019年のデビュー以降、人気は韓国内にとどまらず主要なグローバルチャートでも注目すべき成果を収めている。<br />また、米国シカゴの大型音楽フェスティバル「Lollapalooza」に2年連続(2022~2023)参加し、2023年にはK-POPグループとしては初めてヘッドライナーとして招待されるなど世界の公演市場でも注目されている。<br /><br />セガ公式SNSでも最新情報を発信中！<br /><a
          href="https://www.instagram.com/sega_purikura/"
          ><img
            src="@/assets/Png/News/TXT2/Linkicon_01_IG.jpg"
            style="max-width: 70%;"/></a
        ><a href="https://twitter.com/SEGA_purikura/"
          ><img
            src="@/assets/Png/News/TXT2/Linkicon_02_TW.jpg"
            style="max-width: 50%;"/></a
        ><a href="https://lin.ee/BncFzGc"
          ><img
            src="@/assets/Png/News/TXT2/Linkicon_03_LINE.jpg"
            style="max-width: 50%;"/></a
        ><a href="https://www.tiktok.com/@sega_purikura"
          ><img
            src="@/assets/Png/News/TXT2/Linkicon_04_TT.jpg"
            style="max-width: 50%;"/></a
        ><br />© SEGA<br /><img
          src="@/assets/Png/News/TXT2/20240603_txt2_04.png"
          style="max-width: 80%;"
        />
      </div>
      <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
      <sub-btn @click="onHome()">ホームに戻る</sub-btn>
    </div>
  </div>
</template>

<script>
import Protobuf from "../mixins/protobuf";
import SectionHeader from "../components/SectionHeader";
import SubBtn from "../components/SubBtn.vue";

export default {
  name: "NewsDetail",
  components: { SectionHeader, SubBtn },
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    };
  },
  methods: {
    onNewsList() {
      this.$router.push("/newsList");
    },
    onHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
      max-width: 100%;
    }

    p {
      margin-top: 1em;
    }

    .linkArea {
      .twitter {
        margin: 0 5px;
      }
    }

    .centerBlock {
      display: flex;
      justify-content: center;

      & > a:not(:last-of-type) {
        margin-right: 30px;
      }

      & > a:last-of-type {
        margin-left: 18px;
      }
    }
  }
}
</style>
